import { render, staticRenderFns } from "./pictureAdvertising.vue?vue&type=template&id=231d74f6&scoped=true"
import script from "./pictureAdvertising.vue?vue&type=script&lang=js"
export * from "./pictureAdvertising.vue?vue&type=script&lang=js"
import style0 from "./pictureAdvertising.vue?vue&type=style&index=0&id=231d74f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d74f6",
  null
  
)

export default component.exports